import { Box, Modal, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import classes from "../../styles/verificationModal.module.css";
import Image from "next/legacy/image";
import UtsavTextField from "src/globalModule/components/UtsavTextField";
import { useTranslation } from "react-i18next";
import RegistrationBtn from "./registrationBtn";
import dynamic from "next/dynamic";
import { useReadOTP } from "react-read-otp";
import { CONTACT_NUMBER, SMS_TEMPLATE } from "@utils/constants";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { trackPeopleAuth } from "@utils/analytics/event-analytics";
import { sendOTP } from "src/onboardingModule/queries/auth.queries";
import CloseIcon from "@mui/icons-material/Close";
import { sendOTPOnWhatsapp, verifyOTPOnWhatsapp } from "src/pujaModule/queries/pujas.queries";
import { useRouter } from "next/router";
import whatsappIcon from "../../../../public/assets/newEvent/pujaDetails/whatsapp_icon.webp";
import editIcon from "../../../../public/assets/newEvent/pujaDetails/edit_text.webp";
import whatsappHelpIcon from "../../../../public/assets/newEvent/pujaDetails/whatsapp_fill.webp";
import verifiedIcon from "../../../../public/assets/newEvent/pujaDetails/verified_icon.webp";
const OTPInput = dynamic(() => import("otp-input-react"), {
  ssr: false
});
function AlternateNoVerificationModal({
  open,
  setOpen,
  setErrorModal,
  errorModal,
  alternateNumber,
  setAlternateNumber,
  setAlterNoBtn,
  setAlterNoAdded
  // setUserAccessToken,
}) {
  const [stepNo, setStepNo] = useState(1);
  // const { dispatch: storeDispatch } = useContext(Store);
  const {
    t
  } = useTranslation();
  const router = useRouter();
  const {
    registrationID
  } = router.query;
  // const { registrationDetails } = useSelector((state) => state.pujaBooking);
  const smallScreen = useMediaQuery("(max-width:768px)");
  const [verificationKey, setVerificationKey] = useState("");
  const [otp, setOtp] = useState("");
  useReadOTP(setOtp);
  const [timer, setTimer] = useState(30);
  const [showRetry, setShowRetry] = useState(false);
  const [showResendOTPTxt, setShowResendOTPTxt] = useState(false);
  const [supportWhatsappUrl, setSupportWhatsappUrl] = useState("");

  // const [, setCookie] = useCookies([]);

  const handleClose = () => {
    setOpen(false);
  };
  function handleNumberChange(e) {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/\D/g, "");
    inputValue = inputValue?.replace(/^\+91-/, "")?.replace(/^\+91/, "")
    // ?.replace(/^91-/, "")
    // ?.replace(/^91/, "")
    ?.replace(/^0-/, "")?.replace(/^0/, "")?.replace(" ", "")?.replace("-", "");
    if (inputValue?.length > 10) {
      return;
    }
    setAlternateNumber(inputValue);
  }
  useEffect(() => {
    let supportMsg = `Namaste Utsav Admin,\u2029\u2029Please help me get my Whatsapp OTP at ${alternateNumber} for login.\u2029\u2029Puja ID - ${registrationID}`;
    setSupportWhatsappUrl(`https://api.whatsapp.com/send?phone=91${CONTACT_NUMBER.number}&text=${supportMsg}`);
  }, [alternateNumber]);
  useEffect(() => {
    let intervalId;
    if (timer > 0) {
      intervalId = setInterval(() => {
        setTimer(prevTimer => prevTimer - 1);
      }, 1000);
    } else {
      setShowRetry(true);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [timer]);

  // useEffect(() => {
  //   let c = registrationDetails?.contact?.slice(-10);
  //   setContact(c);
  //   if (c && c.length === 10) sendOTPHandler(c);
  // }, [registrationDetails]);

  useEffect(() => {
    if (otp.length === 6) {
      verifyOTPHandler();
    }
  }, [otp]);
  const sendOTPHandler = async () => {
    // console.log("sendOTPHandler called");
    const res = await sendOTPOnWhatsapp({
      contact: alternateNumber,
      registrationID: registrationID
    });
    if (res?.success && res?.response) {
      trackPeopleAuth(res.response.data);
      // registrationDispatch({
      //   type: "OTP_SENT",
      //   payload: {
      //     name,
      //     contact,
      //     email,
      //     verificationKey: res.response.verificationKey,
      //   },
      // });
      setVerificationKey(res.response.verificationKey);
      setStepNo(2);
    } else {
      setErrorModal({
        open: true,
        heading: `${t("puja-registration")}`,
        message: res.message,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <ErrorOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />
      });
    }
    return () => {};
  };
  const verifyOTPHandler = async () => {
    let res;
    // let encryptedUserData = null,
    //   encryptedUser = null;

    res = await verifyOTPOnWhatsapp({
      contact: alternateNumber,
      otp: otp,
      verificationKey: verificationKey
    });
    if (res?.success && res?.response?.data) {
      trackPeopleAuth(res.response.data);
      setAlterNoAdded(true);
    }
    if (!res?.success && res?.message) {
      setErrorModal({
        open: true,
        // heading: `${t("puja-registration")}`,
        // message: res.message,
        heading: res.message,
        message: "Please check again",
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <ErrorOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />
      });
      //e.target.innerText = "Proceed";
      return () => {};
    }
    if (res?.success) {
      setAlterNoBtn(true);
      setAlterNoAdded(true);
      setOpen(false);
    }
    if (!res?.success) {
      setErrorModal({
        open: true,
        heading: `${t("puja-registration")}`,
        message: `${t("something-went-wrong-please-try-again")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <ErrorOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />
      });
      return () => {};
    }
  };
  const resendOTPHandler = async () => {
    let res = await sendOTP({
      contact: alternateNumber,
      type: SMS_TEMPLATE.WEBSITE
    });
    if (!res?.success && res?.message) {
      setErrorModal({
        open: true,
        heading: `${t("puja-registration")}`,
        message: res.message,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <ErrorOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />
      });
      return () => {};
    }
    if (!res?.success) {
      setErrorModal({
        open: true,
        heading: `${t("puja-registration")}`,
        message: `${t("something-went-wrong-please-try-again")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <ErrorOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />
      });
      return () => {};
    }
    // setErrorModal({
    //   open: true,
    //   heading: `${t("resend-otp")}`,
    //   message: `${t("otp-sent-successfully")}`,
    //   acceptMethod: () => setErrorModal({ ...errorModal, open: false }),
    //   icon: (
    //     <CheckCircleOutlineOutlinedIcon
    //       sx={{ fontSize: "3rem", color: "green" }}
    //     />
    //   ),
    //   positive: true,
    // });
    // setTimer(30);
    // setShowRetry(false);
    setShowRetry(false);
    setShowResendOTPTxt(true);
  };
  useEffect(() => {
    setTimeout(() => {
      setShowResendOTPTxt(false);
      setTimer(30);
      setShowRetry(false);
    }, 10000);
  }, [showResendOTPTxt]);
  return <Modal open={open} onClose={handleClose} data-sentry-element="Modal" data-sentry-component="AlternateNoVerificationModal" data-sentry-source-file="alternateNoVerificationModal.jsx">
      <Box className={classes.modalContainerForAlternateNo} data-sentry-element="Box" data-sentry-source-file="alternateNoVerificationModal.jsx">
        {stepNo === 1 && <div className={classes.modalCard}>
            <div className={classes.modalTop}>
              <Box sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
                <Typography className={classes.headerFont}>
                  Enter WhatsApp number
                </Typography>
                <CloseIcon className={classes.closeIcon} onClick={() => setOpen(false)} />
              </Box>
            </div>
            <UtsavTextField label={t("enter-whatsapp-number")} type="tel" value={alternateNumber} autoComplete="tel" inputProps={{
          inputMode: "numeric",
          pattern: "[0-9]*"
        }} setProps={handleNumberChange} // setProps
        startAdornment={"+91"} endAdornment={<Image src={whatsappIcon} alt="whatsapp-icon" width={30} height={30} />} />

            <RegistrationBtn btnText={"Get OTP on WhatsApp"} disabled={alternateNumber.length !== 10} setProps={sendOTPHandler} />
          </div>}
        {stepNo === 2 && <div className={classes.modalCard}>
            <div className={classes.modalTop}>
              <Box sx={{
            display: "flex",
            gap: "10px",
            alignItems: "center"
          }}>
                <Typography className={classes.headerFont}>
                  {t("Verify OTP")}
                </Typography>
                <div>
                  <Image src={whatsappIcon} alt="whatsapp-icon" width={15} height={15} />
                </div>
              </Box>

              <div className={classes.editIconContainer}>
                <Typography
            // className={classes.headerFont}
            sx={{
              color: "#6F7D83",
              fontSize: "14px"
            }}>
                  {t("otp-sent-to")} +91 {alternateNumber}
                </Typography>
                <Image src={editIcon} alt="edit-icon" width={20} height={15} onClick={() => setStepNo(1)} />
              </div>
            </div>
            <OTPInput value={otp} onChange={otp_input => {
          setOtp(otp_input);
        }} autoFocus OTPLength={6} otpType="number" disabled={false} timeInterval={500} inputClassName={`${classes.otpBox1}`} style={{
          display: "flex",
          justifyContent: smallScreen ? "space-between" : "center",
          alignItems: "center",
          gridTemplateColumns: "repeat(6, 1fr)",
          width: "100%",
          // height: "100%",
          marginLeft: smallScreen ? "0px" : "5px"
        }} />
            {showRetry ? <>
                <div className={classes.resendOTPContainer}>
                  <Typography sx={{
              fontSize: "15px"
            }}>
                    {t("didn-and-apos-t-receive-otp")}
                  </Typography>
                  <span onClick={() => {
              resendOTPHandler();
            }} className={classes.otpResend}>
                    {t("resend-otp-0")}
                  </span>
                </div>
                <div className={classes.getHelpContainer} onClick={() => window.open(supportWhatsappUrl, "_blank")}>
                  <Image src={whatsappHelpIcon} alt="whatsapp" height={20} width={20} />
                  <Typography sx={{
              fontSize: "15px"
            }}>
                    {t("get-help")}
                  </Typography>
                </div>
              </> : showResendOTPTxt ? <div className={classes.resendOTPTxtContainer}>
                <Image src={verifiedIcon} alt="verified icon" height={20} width={25} />
                <span style={{
            color: "green"
          }}>
                  {t("otp-resent-successfully")}
                </span>
              </div> : <span className={classes.otpBxEx2}>
                {t("waiting-for-otp")}
                {" ... "}
                <span style={{
            color: "black"
          }}>
                  {t("retry-in")}{" "}
                  {timer > 0 ? `${String(Math.floor(timer / 60)).padStart(2, "0")}:${String(timer % 60).padStart(2, "0")}` : 0}{" "}
                  s{" "}
                </span>
              </span>}
            <RegistrationBtn btnText={t("submit-otp")} disabled={otp?.length !== 6} setProps={verifyOTPHandler} />
          </div>}
      </Box>
    </Modal>;
}
export default AlternateNoVerificationModal;